import {
  getUser,
  getConnectionWapi,
  getQueue,
  getTags,
  getExpressStatus,
  getExpressRegional,
  getExpressAssociateSituation,
  getExpressBilletSituation,
  getUserMessage,
  getCategories,
  createWapiConnectionWise,
  closeWapiConnectionWise,
  updateUser,
} from '../../../api/wise.js';

export const actions = {
  async loadData({ commit, state }) {
    if (state.load) return;

    try {
      const data = await getUser();
      if (data) {
        commit('setUserData', data[1]);

        const { secret, device_id, _id } = data[1];

        if (_id) {
          const { data: queueData } = await getQueue({ id: _id });
          commit('setQueue', queueData.res);

          const { data: userMessageData } = await getUserMessage({ id: _id });
          commit('setUserMessage', userMessageData.res);
        }

        const { data: expressStatusesData } = await getExpressStatus();
        if (Array.isArray(expressStatusesData))
          commit('setExpressStatuses', expressStatusesData);

        const { data: expressRegionalData } = await getExpressRegional();
        if (Array.isArray(expressRegionalData))
          commit('setExpressRegional', expressRegionalData);

        const {
          data: expressAssociateSituation,
        } = await getExpressAssociateSituation();
        if (Array.isArray(expressAssociateSituation))
          commit('setExpressAssociate', expressAssociateSituation);

        const {
          data: expressBilletSituation,
        } = await getExpressBilletSituation();
        if (Array.isArray(expressBilletSituation))
          commit('setExpressBilletSituation', expressBilletSituation);

        if (secret && device_id) {
          const connectionData = await getConnectionWapi({
            secret,
            id: device_id,
          });
          commit('setConnectionStatus', connectionData);
        }
      }

      commit('setLoad');
    } catch (error) {
      console.error('Erro ao carregar dados de user:', error);
    }
  },

  async loadTags({ commit }) {
    try {
      const { data } = await getTags();
      if (data) commit('setTags', data);
    } catch (error) {
      console.error('Erro ao carregar tags:', error);
    }
  },

  async loadCategoriesMessage({ commit }) {
    try {
      const { data } = await getCategories();
      if (data) commit('setCategories', data);
    } catch (error) {
      console.error('Erro ao carregar categorias:', error);
    }
  },

  async loadUser({ commit }) {
    try {
      const data = await getUser();
      if (data) commit('setUserData', data[1]);
    } catch (err) {
      console.error('Erro ao buscar dados do usuário:', err);
    }
  },

  async loadQueue({ commit, state }) {
    try {
      const { _id } = state.userData;
      const { data: queueData } = await getQueue({ id: _id });
      commit('setQueue', queueData.res);
    } catch (err) {
      console.error('Erro ao buscar dados do usuário:', err);
    }
  },

  async createNewWapiConnectionWise({ commit, state }) {
    try {
      const { secret } = state.userData;
      const { data } = await createWapiConnectionWise({ secret });
      commit('setNewConnectionWapi', data);
      await updateUser({ user: state.userData });
      const userData = await getUser();
      if (data) {
        commit('setUserData', userData[1]);
      }
    } catch (err) {
      console.error('Erro ao buscar conexão do usuário:', err);
    }
  },
  async stopWapiConnectionWise({ commit, state }) {
    try {
      await closeWapiConnectionWise({ user: state.userData });

      commit('setConnectionStatus', {
        clientConnected: false,
      });
    } catch (err) {
      console.error('Erro ao encerrar conexão na Wapi:', err);
    }
  },
  async loadWapiConnectionWise({ commit, state }) {
    const { secret, device_id } = state.userData;
    try {
      if (secret && device_id) {
        const connectionData = await getConnectionWapi({
          secret,
          id: device_id,
        });
        commit('setConnectionStatus', connectionData);
      }
    } catch (err) {
      console.error('Erro ao encerrar conexão na Wapi:', err);
    }
  },

  async loadMessageWise({ commit, state }) {
    try {
      const { _id } = state.userData;
      const { data } = await getUserMessage({ id: _id });
      commit('setUserMessage', data.res);
    } catch (err) {
      console.error('Erro ao buscar mensagens do usuário:', err);
    }
  },

  async updateDashboardData({ commit }) {
    try {
      const data = await getUser();
      if (data) {
        commit('setUserData', data[1]);

        const { _id } = data[1];

        if (_id) {
          const { data: queueData } = await getQueue({ id: _id });
          commit('setQueue', queueData.res);
        }

        const { data: expressStatusesData } = await getExpressStatus();
        if (Array.isArray(expressStatusesData))
          commit('setExpressStatuses', expressStatusesData);

        const { data: expressRegionalData } = await getExpressRegional();
        if (Array.isArray(expressRegionalData))
          commit('setExpressRegional', expressRegionalData);

        const {
          data: expressAssociateSituation,
        } = await getExpressAssociateSituation();
        if (Array.isArray(expressAssociateSituation))
          commit('setExpressAssociate', expressAssociateSituation);

        const {
          data: expressBilletSituation,
        } = await getExpressBilletSituation();
        if (Array.isArray(expressBilletSituation))
          commit('setExpressBilletSituation', expressBilletSituation);
      }
    } catch (error) {
      console.error('Erro ao carregar dados de user:', error);
    }
  },
};
